import d3 from "d3";

import ReStock from "react-stockcharts";
import indicatorOptions from "../constants/customizedIndicatorOptions";

var { MACD, EMA, SMA, BollingerBand, RSI, FullStochasticOscillator } = ReStock.indicator;

var { defaultOptions: transformOptions } = ReStock.transforms;
var { StockscaleTransformer, HeikinAshiTransformer, KagiTransformer, PointAndFigureTransformer, RenkoTransformer } = ReStock.transforms;

import * as ChartTypes from "constants/ChartTypes";

import * as ActionTypes from "../constants/ActionTypes";

var { CHART_SET_PERIOD } = ActionTypes;
var { CHART_PAGE_SET_DATA } = ActionTypes;
var { CHART_SHOW_SETTINGS } = ActionTypes;
var { CHART_SHOW_INDICATOR_SETTINGS, CHART_HIDE_INDICATOR_SETTINGS } = ActionTypes;
var { CHART_PAGE_LAYOUT_CHANGE, CHART_PAGE_RESIZE_COMPLETE } = ActionTypes;
var { CHART_PAGE_EXCHANGE_DROPDOWN_TOGGLE, CHART_PAGE_EXCHANGE_SELECT } = ActionTypes;
var { CHART_PAGE_SECURITY_FOCUS, CHART_PAGE_SECURITY_SEARCH, CHART_PAGE_LOADING, CHART_PAGE_SECURITY_SELECT } = ActionTypes;
var { CHART_PAGE_CHART_TYPE_DROPDOWN_TOGGLE, CHART_PAGE_CHART_TYPE_SELECT } = ActionTypes;
var { CHART_PAGE_CHART_INDICATOR_DROPDOWN_TOGGLE } = ActionTypes;
var { CHART_PAGE_CHART_INDICATOR_ADD, CHART_PAGE_CHART_INDICATOR_REMOVE, CHART_PAGE_CHART_INDICATOR_UPDATE } = ActionTypes;
var { CHART_PAGE_CHART_INTERACTIVE_INDICATOR_DROPDOWN_TOGGLE } = ActionTypes;
var { CHART_PAGE_CHART_INTERACTIVE_INDICATOR_SET } = ActionTypes;
var { CHART_PAGE_CHART_SETTINGS_DROPDOWN_TOGGLE, CHART_PAGE_CHART_SETTINGS_CHANGE  } = ActionTypes;

export const setViewPeriod = (index, period) => ({ type: CHART_SET_PERIOD, index, period });

/*
export function unSetViewPeriod(index) {
	return (dispatch, getState) => {
		var state = getState();
		if (state.chartPage.chartComponent[index].activePeriod) {
			dispatch(setViewPeriod(index, null));
		}
	};
} */

export function changeLayout(layout) {
	return {
		type: CHART_PAGE_LAYOUT_CHANGE,
		layout
	};
}

var parseDate = d3.time.format("%Y-%m-%d").parse;

export function loadData(index, security, exchange) {
	return (dispatch, getState) => {
		d3.tsv(`resources/data/${ security }.tsv`, (err, data) => {
			data.forEach((d, i) => {
				d.date = new Date(parseDate(d.date).getTime());
				d.open = +d.open;
				d.high = +d.high;
				d.low = +d.low;
				d.close = +d.close;
				d.volume = +d.volume;
				// console.log(d);
			});
			dispatch(setData(index, data));
		});
	};
}

export function showChartIndicatorSettings(index, reference, settings) {
	return {
		type: CHART_SHOW_INDICATOR_SETTINGS,
		index,
		settings: { ...reference, ...settings},
	};
}

export function showChartSettings(index, settings) {
	return {
		type: CHART_SHOW_SETTINGS,
		index,
		settings,
	};
}

export function closeChartIndicatorSettings(index) {
	return {
		type: CHART_HIDE_INDICATOR_SETTINGS,
		index,
	};
}

export function updateChartIndicatorSettings(index, indicator) {
	return {
		type: CHART_PAGE_CHART_INDICATOR_UPDATE,
		index,
		indicator,
	};
}

export function setData(index, data) {
	return {
		type: CHART_PAGE_SET_DATA,
		index,
		data
	};
}

export function resizeChartAsync(dimensions) {
	return (dispatch, getState) => {
		setTimeout(() => {
			dispatch(resizeChart(dimensions));
		}, 100);
	};
}

export function resizeChart(width, height) {
	return {
		type: CHART_PAGE_RESIZE_COMPLETE,
		width, height
	};
}

export function exchangeSelectDropDownToggle(index, value) {
	return {
		type: CHART_PAGE_EXCHANGE_DROPDOWN_TOGGLE,
		index,
		value
	};
}
export function exchangeSelect(index, exchange) {
	return {
		type: CHART_PAGE_EXCHANGE_SELECT,
		index,
		exchange
	};
}
export function securityFocus(index) {
	return {
		type: CHART_PAGE_SECURITY_FOCUS,
		index
	};
}
export function showLoading(index) {
	return {
		type: CHART_PAGE_LOADING,
		index
	};
}
export function securitySearch(index, query) {
	return (dispatch, getState) => {
		if (query.length > 2) {
			dispatch(showLoading(index));
			setTimeout(() => {
				let state = getState();
				let { exchange, type } = state.chartPage.chartComponent[index].securitySelector;
				// state.chartPage.chartComponent[index].securitySelector;
				// console.log(index, query, state);
				d3.json(`resources/data/securitysearch.json?q=${ query }&exchange=${ exchange }&type=${ type }`, function(data) {
					// console.log(data);
					dispatch(forSecurities(index, data));
				});
			}, 1000);
		}
	};
}

export function forSecurities(index, securities) {
	return {
		type: CHART_PAGE_SECURITY_SEARCH,
		index,
		securities
	};
}

export function chartTypeSelectDropDownToggle(index, value) {
	return {
		type: CHART_PAGE_CHART_TYPE_DROPDOWN_TOGGLE,
		index,
		value
	};
}

function getTransforms(chartType, opt) {
	var transforms = [ { transform: StockscaleTransformer } ];
	var options;
	// console.log(chartType);
	switch (chartType.value) {
		case ChartTypes.RENKO.value: {
			options = opt || transformOptions.Renko;
			transforms.push({ transform: RenkoTransformer, options });
			break;
		}
		case ChartTypes.HEIKIN_ASHI.value: {
			transforms.push({ transform: HeikinAshiTransformer });
			break;
		}
		case ChartTypes.KAGI.value: {
			options = opt || transformOptions.Kagi;
			transforms.push({ transform: KagiTransformer, options });
			break;
		}
		case ChartTypes.POINT_FIGURE.value: {
			options = opt || transformOptions.PointAndFigure;
			transforms.push({ transform: PointAndFigureTransformer, options });
			break;
		}
	}
	return transforms;
}

export function chartTypeSelect(index, chartType) {

	var transforms = getTransforms(chartType);
	return {
		type: CHART_PAGE_CHART_TYPE_SELECT,
		index,
		chartType,
		transforms,
	};
}

export function changeChartSettings(index, chartType, settings) {
	var transforms = getTransforms(chartType, settings);

	return {
		type: CHART_PAGE_CHART_TYPE_SELECT,
		index,
		chartType,
		transforms,
	};
}

export function indicatorsDropDownToggle(index, value) {
	return {
		type: CHART_PAGE_CHART_INDICATOR_DROPDOWN_TOGGLE,
		index,
		value
	};
}

export function interactiveIndicatorDropDownToggle(index, value) {
	return {
		type: CHART_PAGE_CHART_INTERACTIVE_INDICATOR_DROPDOWN_TOGGLE,
		index,
		value
	};
}

export function addIndicator(index, indicator) {

	return (dispatch, getState) => {
		var state = getState();
		var { list } = state.chartPage.chartComponent[index].indicators;
		var maxChartId = list.map(each => each.chartId)
			.reduce((a, b) => Math.max(a, b), 1);

		var maxDataSeriesId = list.filter(each => each.chartId === 0)
			.map(each => each.dataSeriesId)
			.reduce((a, b) => Math.max(a, b), 0);

		var options, chartId, dataSeriesId;
		switch (indicator) {
			case "BollingerBand": {
				options = indicatorOptions.BollingerBand;
				chartId = 0;
				dataSeriesId = maxDataSeriesId + 1;
				break;
			}
			case "SMA": {
				options = indicatorOptions.SMA;
				chartId = 0;
				dataSeriesId = maxDataSeriesId + 1;
				break;
			}
			case "EMA": {
				options = indicatorOptions.EMA;
				chartId = 0;
				dataSeriesId = maxDataSeriesId + 1;
				break;
			}
			case "MACD": {
				options = indicatorOptions.MACD;
				console.log(options);
				chartId = maxChartId + 1;
				dataSeriesId = 0;
				break;
			}
			case "RSI": {
				options = indicatorOptions.RSI;
				chartId = maxChartId + 1;
				dataSeriesId = 0;
				break;
			}
			case "FullStochasticOscillator": {
				options = indicatorOptions.FullStochasticOscillator;
				chartId = maxChartId + 1;
				dataSeriesId = 0;
				break;
			}
		};
		var indicatorToAdd = { type: indicator, options, chartId, dataSeriesId };
		dispatch(addIndicatorSync(index, indicatorToAdd));
	};
}

function addIndicatorSync(index, indicator) {
	return {
		type: CHART_PAGE_CHART_INDICATOR_ADD,
		index,
		indicator,
	};
}


export function setInteractiveIndicator(index, indicator) {
	return {
		type: CHART_PAGE_CHART_INTERACTIVE_INDICATOR_SET,
		index,
		indicator,
	};
}
export function removeIndicator(index, indicator) {
	return {
		type: CHART_PAGE_CHART_INDICATOR_REMOVE,
		index,
		indicator,
	};
}

export function settingsDropDownToggle(index, value) {
	return {
		type: CHART_PAGE_CHART_SETTINGS_DROPDOWN_TOGGLE,
		index,
		value
	};
}
export function changeSettings(index, settings) {
	return {
		type: CHART_PAGE_CHART_SETTINGS_CHANGE,
		index,
		settings
	};
}



/** WEBPACK FOOTER **
 ** ./src/scripts/actions/ChartPageActions.js
 **/